import { render, staticRenderFns } from "./GovBanner.vue?vue&type=template&id=99133ec4&scoped=true&"
import script from "./GovBanner.vue?vue&type=script&lang=js&"
export * from "./GovBanner.vue?vue&type=script&lang=js&"
import style0 from "./GovBanner.vue?vue&type=style&index=0&id=99133ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99133ec4",
  null
  
)

export default component.exports